import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import API from '../../../../api/api'
import { useSnackbar } from '../../../../helpers/hooks/useSnackbar'

import { uploadFiles } from './uploadEventFiles'

export const useEditEvent = ({ eventType, redirectFn }) => {
  const { t } = useTranslation(['eventManagement'])
  const { displaySnackbar } = useSnackbar()
  const [isLoading, setIsLoading] = useState(false)

  const editEvent = async (id, formData, type) => {
    setIsLoading(true)

    try {
      const jsonResponse = await uploadFiles(formData.image, formData.files, id)
      const toSave = { ...formData }
      delete toSave.image
      delete toSave.files

      await API.updateEvent(id, { ...toSave, ...jsonResponse }, type)
      displaySnackbar(t('eventManagement:common.eventUpdated', { eventType, name: formData.name }))
      redirectFn()
    } catch {
      displaySnackbar(
        t('eventManagement:common.eventUpdateError', { eventType, name: formData.name }),
        true,
      )
    } finally {
      setIsLoading(false)
    }
  }

  return { isLoading, editEvent }
}
